import React, { Component } from 'react';

class ShareLayout extends Component {
    render() {
        return (
            <main>
                {this.props.children}
            </main>
        );
    }
}

export default ShareLayout;
